<template>

    <crud-container :name="name">

        <crud-nav>
            <crud-nav-header title="Employees"></crud-nav-header>

            <crud-nav-scroll>

                <h3 v-if="items.length">Current Employees</h3>
                <ul>
                    <li v-for="employee in current_employees">
                        <div class="name">
                            <a href="#" @click.prevent="viewItem(employee)">
                                {{ employee.name }}
                            </a>
                        </div>
                    </li>
                </ul>

                <h3 v-if="items.length">Previous Employees</h3>
                <ul>
                    <li v-for="employee in previous_employees">
                        <div class="name">
                            <a href="#" @click.prevent="viewItem(employee)">
                                {{ employee.name }}
                            </a>
                        </div>
                    </li>
                </ul>

            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>
                <crud-main-header title="Create New Employee" can-go-back-to-nav="true"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>

                <dl>
                    <dt>Create Employee From Contact</dt>
                    <dd>
                        <v-select v-model="new_item"
                                  placeholder="Choose a contact..."
                                  :options="people"></v-select>
                    </dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" disabled class="action-button action-button-dismiss hidden-desktop" @click.prevent="backToNav()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" disabled class="action-button action-button-success" @click.prevent="addItem()">
                        <i class="fa fa-plus-square-o" aria-hidden="true"></i> Create Employee
                    </a>
                </div>

            </crud-new>
            <crud-edit>
                <crud-main-header :title="'Editing: '+current_item.name" can-delete="true" can-edit="true" can-go-back="true" :item="current_item"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>


                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss" @click.prevent="backToItem()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="saveItem()">
                        <i class="fa fa-check" aria-hidden="true"></i> Update Employee
                    </a>
                </div>

            </crud-edit>
            <crud-view>
                <crud-main-header :title="current_item.name" can-delete="true"  can-go-back-to-nav="true" :item="current_item"></crud-main-header>

                <tab-list v-if="viewing_item">
                    <tab name="Overview" active="true">
                        <dl class="basic-list">
                            <dt>Title</dt>
                            <dd>{{ current_item.title }}</dd>
                            <dt>First Name</dt>
                            <dd>{{ current_item.first_name }}</dd>
                            <dt>Last Name</dt>
                            <dd>{{ current_item.last_name }}</dd>
                            <dt>Email Address</dt>
                            <dd>{{ current_item.email }}</dd>
                            <dt>Phone Number</dt>
                            <dd>{{ current_item.phone }}</dd>
                            <dt>Secondary Phone Number</dt>
                            <dd>{{ current_item.secondary_phone }}</dd>
                        </dl>

                        <hr />

                        <dl class="basic-list">
                            <dt>Date Of Birth</dt>
                            <dd>{{ current_item.date_of_birth }}</dd>
                            <dt>Marital Status</dt>
                            <dd>{{ current_item.marital_status }}</dd>
                            <dt>Dependents</dt>
                            <dd>{{ current_item.dependents }}</dd>
                            <dt>Nationality</dt>
                            <dd>{{ current_item.nationality }}</dd>
                            <dt>Ethnic Origin</dt>
                            <dd>{{ current_item.ethnic_origin }}</dd>
                            <dt>Religion</dt>
                            <dd>{{ current_item.religion }}</dd>
                        </dl>

                        <hr />

                        <dl class="basic-list">
                            <dt>Timesheets Required?</dt>
                            <dd>
                                <input type="checkbox" v-model="current_item.timesheets_required" @change="updateEmployee()" />
                            </dd>
                            <dt v-if="current_item.timesheets_required">Timesheets Start At</dt>
                            <dd v-if="current_item.timesheets_required">
                                <flat-pickr v-model="current_item.timesheet_start_from" @on-close="updateEmployee()" placeholder="When does this employee's timesheets start from..."></flat-pickr>
                            </dd>
                        </dl>

                    </tab>
                    <tab name="Accounting">
                        <dl class="basic-list">
                            <dt>Employment Status</dt>
                            <dd>{{ current_item.status }}</dd>
                            <dt>NI Number</dt>
                            <dd>{{ current_item.ni_number }}</dd>
                        </dl>
                        <hr />
                        <dl class="basic-list">
                            <dt>Bank Name</dt>
                            <dd>{{ current_item.bank_name }}</dd>
                            <dt>Bank Address</dt>
                            <dd>{{ current_item.bank_address }}</dd>
                            <dt>Account Name</dt>
                            <dd>{{ current_item.account_name }}</dd>
                            <dt>Account Number</dt>
                            <dd>{{ current_item.account_number }}</dd>
                            <dt>Account Sort Code</dt>
                            <dd>{{ current_item.account_sort_code }}</dd>
                        </dl>
                    </tab>
                    <tab name="Contacts">
                        <dl class="basic-list">
                            <dt>Emergency Contact Name</dt>
                            <dd>{{ current_item.emergency_contact_name }}</dd>
                            <dt>Emergency Contact Relationship</dt>
                            <dd>{{ current_item.emergency_contact_relationship }}</dd>
                            <dt>Emergency Contact Phone 1</dt>
                            <dd>{{ current_item.emergency_contact_phone_1 }}</dd>
                            <dt>Emergency Contact Phone 2</dt>
                            <dd>{{ current_item.emergency_contact_phone_2 }}</dd>
                        </dl>
                        <hr />
                        <dl class="basic-list">
                            <dt>Website</dt>
                            <dd>{{ current_item.website }}</dd>
                            <dt>LinkedIn</dt>
                            <dd>{{ current_item.linkedin }}</dd>
                            <dt>Twitter</dt>
                            <dd>{{ current_item.twitter }}</dd>
                            <dt>Facebook</dt>
                            <dd>{{ current_item.facebook }}</dd>
                        </dl>
                    </tab>
                    <tab name="HR">
                        <dl class="basic-list">
                            <dt>Job Title</dt>
                            <dd>{{ current_item.job_title }}</dd>
                            <dt>Employment Type</dt>
                            <dd>{{ current_item.employment_type }}</dd>
                            <dt>How Recruited</dt>
                            <dd>{{ current_item.how_recruited }}</dd>
                            <dt>Recruitment Cost</dt>
                            <dd>{{ current_item.recruitment_cost }}</dd>
                        </dl>
                        <hr />
                        <dl class="basic-list">
                            <dt>Date Started</dt>
                            <dd>{{ current_item.date_started }}</dd>
                            <dt>Date Left</dt>
                            <dd>{{ current_item.date_left }}</dd>
                        </dl>
                    </tab>
                    <tab name="Medical">
                        <dl class="basic-list">
                            <dt>Medical Conditions</dt>
                            <dd>{{ current_item.medical_conditions  }}</dd>
                            <dt>Medication</dt>
                            <dd>{{ current_item.medication }}</dd>
                        </dl>
                    </tab>
                    <tab name="Hobbies">
                        <dl class="basic-list">
                            <dt>Hobbies</dt>
                            <dd>{{ current_item.hobbies }}</dd>
                        </dl>
                    </tab>
                    <tab v-if="current_item.PPE.data.length" name="PPE">
                        <dl class="basic-list">
                            <div v-for="ppe in current_item.PPE.data">
                                <dt>{{ ppe.name }}</dt>
                                <dd v-if="ppe.expires">Expires: {{ ppe.expires }}</dd>
                                <dd v-else>No expiry</dd>
                            </div>
                        </dl>
                    </tab>
                    <tab v-if="current_item.training.data.length" name="Training">
                        <dl class="basic-list">
                            <div v-for="ppe in current_item.training.data">
                                <dt>{{ ppe.name }}</dt>
                                <dd v-if="ppe.expires">Expires: {{ ppe.expires }}</dd>
                                <dd v-else>No expiry</dd>
                            </div>
                        </dl>
                    </tab>
                    <tab name="Notes">
                        <notes :get-url="current_item.notes_url" :post-url="current_item.notes_url"></notes>
                    </tab>
                    <tab name="Files">
                        <filesystem compact="true" v-if="show_files" :filesystem-id="current_item.filesystem_id"></filesystem>
                    </tab>
                </tab-list>

            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
    import vSelect from "vue-select";
    import flatPickr from 'vue-flatpickr-component';

    export default {
        components: {
            vSelect, flatPickr
        },
        data() {
            return {
                name: 'employees',
                items: [],
                show_files: false,
                current_item: {},
                search_query: null,
                errors: null,
                people:[]
            }
        },
        watch: {
            current_item() {
                this.show_files = false;
                if (!_.isEmpty(this.current_item)) {
                    this.show_files = true;
                }
            }
        },
        filters: {},
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            },
            viewing_item(){
                return !_.isEmpty(this.current_item);
            },
            previous_employees(){
                return _.filter(this.items,function(item){
                   return !item.is_current;
                });
            },
            current_employees(){
                return _.filter(this.items,function(item){
                    return item.is_current;
                });
            }
        },
        methods: {
            refreshCurrentItem(){
                var that = this;
                var url = appUrls.employees.show.replace('REPLACEME',this.current_item.id);

                axios.get(url)
                    .then(response => {
                        that.current_item = response.data.data;
                    });
            },
            updateEmployee: _.debounce(function(){
                this.saveItem();
            },100),
            saveItem: function () {
                var that = this;
                var formDataObject = new FormData();
                var editingItem = $.extend({}, this.current_item);
                var saveUrl = appUrls.employees.update.replace('REPLACEME', editingItem.id);

                _.forIn(editingItem, function (value, key) {
                    if( !_.isNull(value) )
                    {
                        formDataObject.append(key, value);
                    }
                });

                formDataObject.append('_method', 'put');

                axios.request({
                    method: 'post',
                    url: saveUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    that.current_item = response.data.data;
                    that.viewItem(that.current_item);

                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },

            deleteItem(itemToDelete) {
                var that = this;
                var title = 'Are you sure you want to delete "' + itemToDelete.name + '"?';
                var description = 'Deleting this employee is irreversible. Are you sure you want to delete them?';
                var standardCallback = function (itemToDelete) {
                    let index = that.items.indexOf(itemToDelete);
                    that.items.splice(index, 1);

                    eventBus.$emit('crud-show-new-' + that.name);
                    eventBus.$emit('crud-back-to-nav-' + that.name);
                };

                eventBus.$emit('delete-modal-open', title, description, function () {
                    axios.delete(appUrls.employees.destroy.replace('REPLACEME', itemToDelete.id));
                    standardCallback(itemToDelete);
                });
            },
            resetErrors() {
                this.errors = null;
            },
            getPeople() {
                var that = this;
                this.people = [];
                axios.get(appUrls.contacts.index)
                    .then(response => {
                        _.forEach(response.data.data, function (user) {
                            var userExists = _.find(that.items, { 'id': user.id});
                            if( !userExists ){
                                that.people.push({
                                    label: user.name,
                                    value: user.id
                                });
                            }
                        });
                    });
            },
            addItem() {
                var that = this;
                var formDataObject = new FormData();
                formDataObject.append('person_id',this.new_item.value)
                var addUrl = appUrls.employees.store;

                var standardCallback = function (item) {
                    that.items.push(item);
                    that.viewItem(item);

                };

                axios.request({
                    method: 'post',
                    url: addUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    standardCallback(response.data.data);

                    // Any other custom methods here.
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },

            // The Big Daddy Of Methods - Retrieves all methods.
            getItems() {
                var that = this;
                var url = appUrls.employees.index;
                var getVarName = 'employee';
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.getPeople();
                        var hasGetVariable = location.search.indexOf(getVarName + '=') >= 0;

                        if (hasGetVariable) {
                            var idFromVariable = getParameterByName(getVarName);
                            if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                                that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                            }
                        }
                    });
            },

            viewItem(item) {
                window.eventBus.$emit('crud-view-item-' + this.name, item);
            },
            backToNav: function () {
                window.eventBus.$emit('crud-back-to-nav-' + this.name);
            },
            backToItem: function () {
                window.eventBus.$emit('crud-back-' + this.name);
            }
        },
        mounted() {
            var that = this;
            this.getItems();

            window.eventBus.$on('crud-search-query-changed-'+this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });

            window.eventBus.$on('crud-edit-item-' + this.name, function (item) {
                this.new_item = null;
                this.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-delete-item-' + this.name, function (item) {
                that.deleteItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-view-item-' + this.name, function (item) {
                that.new_item = null;
                that.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-' + this.name, function (item) {
                that.current_item = item;
                that.viewItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
                that.current_item = {};
                that.new_item = null;
                that.resetErrors();
            });
        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>